/**
 * @file searchDebounceTime.ts
 * @description
 * -----------------------------------------------------
 * Archivo que la constante de tiempo de debounce para la búsqueda
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-05-19
 * @author DLTCode
 * @author Mohammed Derfoufi
 * @copyright © DLTCode
 * @license Private
 * */

export const SEARCH_DEBOUNCE_TIME = 500;
